import axiosInstance from 'api/axiosInstance';
import { CANtrackCommentRaw } from './getComments';

interface RecentCommentsPayload {
	ConsultantId?: string;
	CustomerId?: number;
	Take?: number;
	Page?: number;
}

export interface RecentCommentsResult {
	data: CANtrackCommentRaw[];
	totalResults: number;
}

async function getRecentComments(
	filters: RecentCommentsPayload = {},
): Promise<RecentCommentsResult> {
	const payload: Record<string, unknown> = {
		Take: filters.Take ?? 50,
		Page: filters.Page ?? 1,
	};
	if (filters.ConsultantId) payload.ConsultantId = filters.ConsultantId;
	if (filters.CustomerId) payload.CustomerId = filters.CustomerId;

	const res = await axiosInstance.get(
		`/api/cantrackv3/ReadComments?payload=${JSON.stringify(payload)}`,
	);
	if (!res || !res.data.Data)
		throw new Error('Failed to fetch comments');
	return {
		data: res.data.Data,
		totalResults: res.data.TotalResults ?? res.data.Data.length,
	};
}

export default getRecentComments;
